


import {SystemDataVM} from './SystemDataVM';
export class NationalityVM extends SystemDataVM {
    
}
